import { ToggleAllClipsFormProps } from './ToggleAllClipsForm';
import ToggleAllClipsModal from './ToggleAllClipsModal';

export default ToggleAllClipsModal;
export type { ToggleAllClipsFormProps };
